import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { colors, header } from 'src/theme';
import { mq, useAppDispatch, useAppSelector } from 'src/common';
import { hideMessage } from 'src/common/redux/state/message.slice';
import { keyframes } from '@emotion/react';
import { Text } from '../typography';

export const Message = () => {
  const dispatch = useAppDispatch();
  const { visible, message, duration, backgroundColor } = useAppSelector((state) => state.state.message);

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        dispatch(hideMessage());
      }, duration);

      return () => clearTimeout(timer);
    }

    return undefined;
  }, [visible, duration, dispatch]);

  const slideInFromTop = keyframes`
    0% {
      transform: translateY(-100%) translateX(-50%);
      opacity: 0;
    }
    100% {
      transform: translateY(0) translateX(-50%);
      opacity: 1;
    }
  `;

  const MessageStyle = styled.div(
    mq({
      position: 'fixed',
      top: header.height + 16,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 90,
      borderRadius: 6,
      padding: '8px 6px',
      backgroundColor,
      width: ['98vw', '98vw', 'auto', 'auto', 'auto'],
      animation: `${slideInFromTop} 0.5s ease-in-out`,
      display: 'flex',
      justifyContent: 'center'
    })
  );

  return visible ? (
    <MessageStyle>
      <Text type="small" color={colors.text1}>
        {message}
      </Text>
    </MessageStyle>
  ) : null;
};
